// GENERATED FILE — do not edit. Run `pnpm dict:generate`. See ADR 0003.
import type { Taxonomy } from '../types.js'

export const taxonomies: Record<string, Taxonomy[]> = {
  "sectors": [
    {
      "slug": "financial-services",
      "name": "Financial Services"
    },
    {
      "slug": "technology",
      "name": "Technology"
    },
    {
      "slug": "consumer-goods",
      "name": "Consumer Goods & Services"
    },
    {
      "slug": "healthcare",
      "name": "Healthcare"
    },
    {
      "slug": "energy-utilities",
      "name": "Energy & Utilities"
    },
    {
      "slug": "agriculture",
      "name": "Agriculture"
    },
    {
      "slug": "industrials",
      "name": "Industrials"
    },
    {
      "slug": "telecommunications",
      "name": "Telecommunications"
    },
    {
      "slug": "real-estate",
      "name": "Real Estate"
    },
    {
      "slug": "transport-logistics",
      "name": "Transport & Logistics"
    },
    {
      "slug": "education",
      "name": "Education"
    },
    {
      "slug": "media-entertainment",
      "name": "Media & Entertainment"
    },
    {
      "slug": "mining-natural-resources",
      "name": "Mining & Natural Resources"
    },
    {
      "slug": "construction",
      "name": "Construction"
    },
    {
      "slug": "hospitality-tourism",
      "name": "Hospitality & Tourism"
    },
    {
      "slug": "professional-services",
      "name": "Professional Services"
    }
  ],
  "subsectors": [
    {
      "slug": "payments",
      "name": "Payments",
      "sector": "financial-services"
    },
    {
      "slug": "msme-lending",
      "name": "MSME Lending",
      "sector": "financial-services"
    },
    {
      "slug": "microfinance-institutions",
      "name": "Microfinance Institutions",
      "sector": "financial-services"
    },
    {
      "slug": "fintech-platforms-other",
      "name": "FinTech Platforms (Other)",
      "sector": "financial-services"
    },
    {
      "slug": "banking",
      "name": "Banking",
      "sector": "financial-services"
    },
    {
      "slug": "insurance",
      "name": "Insurance",
      "sector": "financial-services"
    },
    {
      "slug": "insurtech",
      "name": "InsurTech",
      "sector": "financial-services"
    },
    {
      "slug": "asset-management",
      "name": "Asset Management",
      "sector": "financial-services"
    },
    {
      "slug": "mutual-funds",
      "name": "Mutual Funds",
      "sector": "financial-services"
    },
    {
      "slug": "pension-management",
      "name": "Pension Management",
      "sector": "financial-services"
    },
    {
      "slug": "wealth-management",
      "name": "Wealth Management",
      "sector": "financial-services"
    },
    {
      "slug": "capital-markets",
      "name": "Capital Markets",
      "sector": "financial-services"
    },
    {
      "slug": "enterprise-software",
      "name": "Enterprise Software",
      "sector": "technology"
    },
    {
      "slug": "marketplaces",
      "name": "Marketplaces",
      "sector": "technology"
    },
    {
      "slug": "data-analytics",
      "name": "Data & Analytics",
      "sector": "technology"
    },
    {
      "slug": "cloud-infrastructure",
      "name": "Cloud & Infrastructure",
      "sector": "technology"
    },
    {
      "slug": "cybersecurity",
      "name": "Cybersecurity",
      "sector": "technology"
    },
    {
      "slug": "e-commerce",
      "name": "E-Commerce",
      "sector": "consumer-goods"
    },
    {
      "slug": "food-beverage",
      "name": "Food & Beverage",
      "sector": "consumer-goods"
    },
    {
      "slug": "fmcg",
      "name": "FMCG",
      "sector": "consumer-goods"
    },
    {
      "slug": "retail",
      "name": "Retail",
      "sector": "consumer-goods"
    },
    {
      "slug": "clinics-hospitals",
      "name": "Clinics & Hospitals",
      "sector": "healthcare"
    },
    {
      "slug": "pharmaceuticals",
      "name": "Pharmaceuticals",
      "sector": "healthcare"
    },
    {
      "slug": "healthtech",
      "name": "HealthTech",
      "sector": "healthcare"
    },
    {
      "slug": "renewables",
      "name": "Renewables",
      "sector": "energy-utilities"
    },
    {
      "slug": "oil-gas",
      "name": "Oil & Gas",
      "sector": "energy-utilities"
    },
    {
      "slug": "power-generation",
      "name": "Power Generation",
      "sector": "energy-utilities"
    },
    {
      "slug": "off-grid-solar",
      "name": "Off-Grid Solar",
      "sector": "energy-utilities"
    },
    {
      "slug": "agri-inputs",
      "name": "Agri Inputs",
      "sector": "agriculture"
    },
    {
      "slug": "agri-processing",
      "name": "Agri Processing",
      "sector": "agriculture"
    },
    {
      "slug": "agritech",
      "name": "AgriTech",
      "sector": "agriculture"
    },
    {
      "slug": "manufacturing",
      "name": "Manufacturing",
      "sector": "industrials"
    },
    {
      "slug": "packaging",
      "name": "Packaging",
      "sector": "industrials"
    },
    {
      "slug": "mobile-network-operators",
      "name": "Mobile Network Operators",
      "sector": "telecommunications"
    },
    {
      "slug": "telecom-infrastructure",
      "name": "Telecom Infrastructure",
      "sector": "telecommunications"
    },
    {
      "slug": "commercial-property",
      "name": "Commercial Property",
      "sector": "real-estate"
    },
    {
      "slug": "residential-property",
      "name": "Residential Property",
      "sector": "real-estate"
    },
    {
      "slug": "logistics-delivery",
      "name": "Logistics & Delivery",
      "sector": "transport-logistics"
    },
    {
      "slug": "mobility",
      "name": "Mobility",
      "sector": "transport-logistics"
    },
    {
      "slug": "edtech",
      "name": "EdTech",
      "sector": "education"
    },
    {
      "slug": "schools-universities",
      "name": "Schools & Universities",
      "sector": "education"
    },
    {
      "slug": "media-publishing",
      "name": "Media & Publishing",
      "sector": "media-entertainment"
    },
    {
      "slug": "mining",
      "name": "Mining",
      "sector": "mining-natural-resources"
    },
    {
      "slug": "construction-engineering",
      "name": "Construction & Engineering",
      "sector": "construction"
    },
    {
      "slug": "hotels-leisure",
      "name": "Hotels & Leisure",
      "sector": "hospitality-tourism"
    },
    {
      "slug": "legal-advisory",
      "name": "Legal & Advisory",
      "sector": "professional-services"
    }
  ],
  "countries": [
    {
      "slug": "nigeria",
      "name": "Nigeria",
      "region": "western-africa"
    },
    {
      "slug": "ghana",
      "name": "Ghana",
      "region": "western-africa"
    },
    {
      "slug": "senegal",
      "name": "Senegal",
      "region": "western-africa"
    },
    {
      "slug": "cote-divoire",
      "name": "Côte d'Ivoire",
      "region": "western-africa"
    },
    {
      "slug": "mali",
      "name": "Mali",
      "region": "western-africa"
    },
    {
      "slug": "benin",
      "name": "Benin",
      "region": "western-africa"
    },
    {
      "slug": "togo",
      "name": "Togo",
      "region": "western-africa"
    },
    {
      "slug": "burkina-faso",
      "name": "Burkina Faso",
      "region": "western-africa"
    },
    {
      "slug": "sierra-leone",
      "name": "Sierra Leone",
      "region": "western-africa"
    },
    {
      "slug": "liberia",
      "name": "Liberia",
      "region": "western-africa"
    },
    {
      "slug": "guinea",
      "name": "Guinea",
      "region": "western-africa"
    },
    {
      "slug": "kenya",
      "name": "Kenya",
      "region": "eastern-africa"
    },
    {
      "slug": "tanzania",
      "name": "Tanzania",
      "region": "eastern-africa"
    },
    {
      "slug": "uganda",
      "name": "Uganda",
      "region": "eastern-africa"
    },
    {
      "slug": "rwanda",
      "name": "Rwanda",
      "region": "eastern-africa"
    },
    {
      "slug": "ethiopia",
      "name": "Ethiopia",
      "region": "eastern-africa"
    },
    {
      "slug": "somalia",
      "name": "Somalia",
      "region": "eastern-africa"
    },
    {
      "slug": "burundi",
      "name": "Burundi",
      "region": "eastern-africa"
    },
    {
      "slug": "south-sudan",
      "name": "South Sudan",
      "region": "eastern-africa"
    },
    {
      "slug": "south-africa",
      "name": "South Africa",
      "region": "southern-africa"
    },
    {
      "slug": "botswana",
      "name": "Botswana",
      "region": "southern-africa"
    },
    {
      "slug": "namibia",
      "name": "Namibia",
      "region": "southern-africa"
    },
    {
      "slug": "zambia",
      "name": "Zambia",
      "region": "southern-africa"
    },
    {
      "slug": "zimbabwe",
      "name": "Zimbabwe",
      "region": "southern-africa"
    },
    {
      "slug": "mozambique",
      "name": "Mozambique",
      "region": "southern-africa"
    },
    {
      "slug": "malawi",
      "name": "Malawi",
      "region": "southern-africa"
    },
    {
      "slug": "mauritius",
      "name": "Mauritius",
      "region": "southern-africa"
    },
    {
      "slug": "egypt",
      "name": "Egypt",
      "region": "northern-africa"
    },
    {
      "slug": "morocco",
      "name": "Morocco",
      "region": "northern-africa"
    },
    {
      "slug": "tunisia",
      "name": "Tunisia",
      "region": "northern-africa"
    },
    {
      "slug": "algeria",
      "name": "Algeria",
      "region": "northern-africa"
    },
    {
      "slug": "libya",
      "name": "Libya",
      "region": "northern-africa"
    },
    {
      "slug": "sudan",
      "name": "Sudan",
      "region": "northern-africa"
    },
    {
      "slug": "cameroon",
      "name": "Cameroon",
      "region": "central-africa"
    },
    {
      "slug": "drc",
      "name": "Democratic Republic of the Congo",
      "region": "central-africa"
    },
    {
      "slug": "gabon",
      "name": "Gabon",
      "region": "central-africa"
    },
    {
      "slug": "chad",
      "name": "Chad",
      "region": "central-africa"
    },
    {
      "slug": "congo",
      "name": "Republic of the Congo",
      "region": "central-africa"
    },
    {
      "slug": "united-kingdom",
      "name": "United Kingdom",
      "region": "europe"
    },
    {
      "slug": "united-states",
      "name": "United States",
      "region": "northern-america"
    },
    {
      "slug": "netherlands",
      "name": "Netherlands",
      "region": "europe"
    },
    {
      "slug": "france",
      "name": "France",
      "region": "europe"
    },
    {
      "slug": "united-arab-emirates",
      "name": "United Arab Emirates",
      "region": "middle-east"
    },
    {
      "slug": "mauritius-ibc",
      "name": "Mauritius (IBC)",
      "region": "southern-africa"
    },
    {
      "slug": "cayman-islands",
      "name": "Cayman Islands",
      "region": "americas"
    },
    {
      "slug": "luxembourg",
      "name": "Luxembourg",
      "region": "europe"
    }
  ],
  "regions": [
    {
      "slug": "global",
      "name": "Global"
    },
    {
      "slug": "pan-african",
      "name": "Pan-African"
    },
    {
      "slug": "sub-saharan-africa",
      "name": "Sub-Saharan Africa"
    },
    {
      "slug": "northern-africa",
      "name": "Northern Africa"
    },
    {
      "slug": "eastern-africa",
      "name": "Eastern Africa"
    },
    {
      "slug": "western-africa",
      "name": "Western Africa"
    },
    {
      "slug": "central-africa",
      "name": "Central Africa"
    },
    {
      "slug": "southern-africa",
      "name": "Southern Africa"
    },
    {
      "slug": "europe",
      "name": "Europe"
    },
    {
      "slug": "asia",
      "name": "Asia"
    },
    {
      "slug": "middle-east",
      "name": "Middle East"
    },
    {
      "slug": "americas",
      "name": "Americas"
    },
    {
      "slug": "southern-america",
      "name": "Southern America"
    },
    {
      "slug": "northern-america",
      "name": "Northern America"
    },
    {
      "slug": "central-america",
      "name": "Central America"
    },
    {
      "slug": "latin-america",
      "name": "Latin America"
    },
    {
      "slug": "australia",
      "name": "Australia"
    },
    {
      "slug": "eurasia",
      "name": "Eurasia"
    },
    {
      "slug": "oceania",
      "name": "Oceania"
    }
  ],
  "currencies": [
    {
      "slug": "USD",
      "name": "USD"
    },
    {
      "slug": "NGN",
      "name": "NGN"
    },
    {
      "slug": "ZAR",
      "name": "ZAR"
    },
    {
      "slug": "KES",
      "name": "KES"
    },
    {
      "slug": "GHS",
      "name": "GHS"
    },
    {
      "slug": "EGP",
      "name": "EGP"
    },
    {
      "slug": "MAD",
      "name": "MAD"
    },
    {
      "slug": "TZS",
      "name": "TZS"
    },
    {
      "slug": "UGX",
      "name": "UGX"
    },
    {
      "slug": "RWF",
      "name": "RWF"
    },
    {
      "slug": "XOF",
      "name": "XOF"
    },
    {
      "slug": "XAF",
      "name": "XAF"
    },
    {
      "slug": "ZMW",
      "name": "ZMW"
    },
    {
      "slug": "MUR",
      "name": "MUR"
    },
    {
      "slug": "EUR",
      "name": "EUR"
    },
    {
      "slug": "GBP",
      "name": "GBP"
    }
  ],
  "exchanges": [
    {
      "slug": "ngx",
      "name": "Nigerian Exchange (NGX)"
    },
    {
      "slug": "jse",
      "name": "Johannesburg Stock Exchange (JSE)"
    },
    {
      "slug": "nse-kenya",
      "name": "Nairobi Securities Exchange (NSE)"
    },
    {
      "slug": "gse",
      "name": "Ghana Stock Exchange (GSE)"
    },
    {
      "slug": "egx",
      "name": "Egyptian Exchange (EGX)"
    },
    {
      "slug": "brvm",
      "name": "Bourse Régionale des Valeurs Mobilières (BRVM)"
    },
    {
      "slug": "cse",
      "name": "Casablanca Stock Exchange"
    },
    {
      "slug": "lse",
      "name": "London Stock Exchange"
    },
    {
      "slug": "nasdaq",
      "name": "Nasdaq"
    },
    {
      "slug": "nyse",
      "name": "New York Stock Exchange"
    },
    {
      "slug": "other",
      "name": "Other"
    }
  ],
  "gp_investor_types": [
    {
      "slug": "venture-capital",
      "name": "Venture Capital"
    },
    {
      "slug": "private-equity",
      "name": "Private Equity"
    },
    {
      "slug": "high-net-worth-individuals",
      "name": "High Net-Worth Individuals (HNIs)"
    },
    {
      "slug": "development-finance-institution",
      "name": "Development Finance Institution"
    },
    {
      "slug": "corporate-venture-capital",
      "name": "Corporate Venture Capital"
    },
    {
      "slug": "angel-network",
      "name": "Angel Network"
    },
    {
      "slug": "sovereign-wealth-fund",
      "name": "Sovereign Wealth Fund"
    },
    {
      "slug": "family-office",
      "name": "Family Office"
    },
    {
      "slug": "private-credit",
      "name": "Private Credit"
    },
    {
      "slug": "corporate-strategic-investor",
      "name": "Corporate Strategic Investor"
    }
  ],
  "lp_types": [
    {
      "slug": "asset-manager",
      "name": "Asset Manager"
    },
    {
      "slug": "corporate-investor",
      "name": "Corporate Investor"
    },
    {
      "slug": "development-finance-institution",
      "name": "Development Finance Institution"
    },
    {
      "slug": "family-office",
      "name": "Family Office"
    },
    {
      "slug": "foundation-endowment",
      "name": "Foundation/Endowment"
    },
    {
      "slug": "fund-of-funds",
      "name": "Fund of Funds"
    },
    {
      "slug": "insurance-company",
      "name": "Insurance Company"
    },
    {
      "slug": "investment-bank",
      "name": "Investment Bank"
    },
    {
      "slug": "pension-fund",
      "name": "Pension Fund"
    },
    {
      "slug": "sovereign-wealth-fund",
      "name": "Sovereign Wealth Fund"
    },
    {
      "slug": "high-net-worth-individuals",
      "name": "High Net-Worth Individuals (HNIs)"
    }
  ],
  "investment_stages": [
    {
      "slug": "pre-seed",
      "name": "Pre-seed"
    },
    {
      "slug": "seed",
      "name": "Seed"
    },
    {
      "slug": "series-a",
      "name": "Series A"
    },
    {
      "slug": "series-b",
      "name": "Series B"
    },
    {
      "slug": "series-c",
      "name": "Series C"
    },
    {
      "slug": "series-d+",
      "name": "Series D+"
    },
    {
      "slug": "growth-stage",
      "name": "Growth Stage"
    },
    {
      "slug": "growth-equity",
      "name": "Growth Equity"
    },
    {
      "slug": "buyout",
      "name": "Buyout"
    }
  ],
  "ticket_sizes": [
    {
      "slug": "lt-100k",
      "name": "< 100K"
    },
    {
      "slug": "100k-500k",
      "name": "100K - 500K"
    },
    {
      "slug": "500k-1m",
      "name": "500K - 1 Mn"
    },
    {
      "slug": "1m-3m",
      "name": "1 Mn - 3 Mn"
    },
    {
      "slug": "3m-5m",
      "name": "3 Mn - 5 Mn"
    },
    {
      "slug": "5m-15m",
      "name": "5 Mn - 15 Mn"
    },
    {
      "slug": "15m-30m",
      "name": "15 Mn - 30 Mn"
    },
    {
      "slug": "30m-50m",
      "name": "30 Mn - 50 Mn"
    },
    {
      "slug": "50m-70m",
      "name": "50 Mn - 70 Mn"
    },
    {
      "slug": "70m-100m",
      "name": "70 Mn - 100 Mn"
    },
    {
      "slug": "100m-200m",
      "name": "100 Mn to 200 Mn"
    }
  ],
  "fund_ticket_sizes": [
    {
      "slug": "lt-100k",
      "name": "< 100K"
    },
    {
      "slug": "100k-500k",
      "name": "100K - 500K"
    },
    {
      "slug": "500k-1m",
      "name": "500K - 1 Mn"
    },
    {
      "slug": "1m-25m",
      "name": "1 Mn - 25 Mn"
    },
    {
      "slug": "25m-50m",
      "name": "25 Mn - 50 Mn"
    },
    {
      "slug": "50m-100m",
      "name": "50 Mn - 100 Mn"
    },
    {
      "slug": "100m-500m",
      "name": "100 Mn - 500 Mn"
    },
    {
      "slug": "gt-500m",
      "name": "More than 500 Mn"
    }
  ],
  "investor_statuses": [
    {
      "slug": "actively-seeking",
      "name": "Actively seeking new investments"
    },
    {
      "slug": "out-of-business",
      "name": "Out of business"
    },
    {
      "slug": "fully-invested",
      "name": "Fully invested, no longer seeking new investments"
    },
    {
      "slug": "acquired-merged",
      "name": "Acquired/Merged"
    },
    {
      "slug": "acquired-merged-operating-subsidiary",
      "name": "Acquired/Merged (Operating subsidiary)"
    },
    {
      "slug": "not-making-new-investments",
      "name": "Not making new investments"
    },
    {
      "slug": "reducing-investment-activity",
      "name": "Reducing investment activity"
    },
    {
      "slug": "will-consider",
      "name": "Will consider new projects"
    }
  ],
  "investment_sectors": [
    {
      "slug": "sector-agnostic",
      "name": "Sector Agnostic"
    },
    {
      "slug": "financial-services",
      "name": "Financial Services"
    },
    {
      "slug": "energy-utilities",
      "name": "Energy & Utilities"
    },
    {
      "slug": "consumer-staples",
      "name": "Consumer Staples"
    },
    {
      "slug": "consumer-discretionary",
      "name": "Consumer Discretionary"
    },
    {
      "slug": "information-technology",
      "name": "Information Technology"
    },
    {
      "slug": "communication-services",
      "name": "Communication Services"
    },
    {
      "slug": "agriculture",
      "name": "Agriculture"
    },
    {
      "slug": "industrials",
      "name": "Industrials"
    },
    {
      "slug": "healthcare",
      "name": "Healthcare"
    },
    {
      "slug": "real-estate",
      "name": "Real Estate"
    },
    {
      "slug": "materials",
      "name": "Materials"
    }
  ],
  "fund_sector_focus": [
    {
      "slug": "sector-agnostic",
      "name": "Sector Agnostic"
    },
    {
      "slug": "macroeconomy",
      "name": "Macroeconomy"
    },
    {
      "slug": "financial-services",
      "name": "Financial Services"
    },
    {
      "slug": "energy-utilities",
      "name": "Energy & Utilities"
    },
    {
      "slug": "consumer-staples",
      "name": "Consumer Staples"
    },
    {
      "slug": "consumer-discretionary",
      "name": "Consumer Discretionary"
    },
    {
      "slug": "information-technology",
      "name": "Information Technology"
    },
    {
      "slug": "communication-services",
      "name": "Communication Services"
    },
    {
      "slug": "agriculture",
      "name": "Agriculture"
    },
    {
      "slug": "industrials",
      "name": "Industrials"
    },
    {
      "slug": "healthcare",
      "name": "Healthcare"
    },
    {
      "slug": "real-estate",
      "name": "Real Estate"
    },
    {
      "slug": "materials",
      "name": "Materials"
    }
  ],
  "sdg_focuses": [
    {
      "slug": "sdg-1-(no-poverty)",
      "name": "SDG 1 (No Poverty)"
    },
    {
      "slug": "sdg-2-(zero-hunger)",
      "name": "SDG 2 (Zero Hunger)"
    },
    {
      "slug": "sdg-3-(good-health-and-well-being)",
      "name": "SDG 3 (Good Health and Well-Being)"
    },
    {
      "slug": "sdg-4-(quality-education)",
      "name": "SDG 4 (Quality Education)"
    },
    {
      "slug": "sdg-5-(gender-equality)",
      "name": "SDG 5 (Gender Equality)"
    },
    {
      "slug": "sdg-6-(clean-water-and-sanitation)",
      "name": "SDG 6 (Clean Water and Sanitation)"
    },
    {
      "slug": "sdg-7-(affordable-and-clean-energy)",
      "name": "SDG 7 (Affordable and Clean Energy)"
    },
    {
      "slug": "sdg-8-(decent-work-and-economic-growth)",
      "name": "SDG 8 (Decent Work and Economic Growth)"
    },
    {
      "slug": "sdg-9-(industry-innovation-and-infrastructure)",
      "name": "SDG 9 (Industry Innovation and Infrastructure)"
    },
    {
      "slug": "sdg-10-(reduced-inequalities)",
      "name": "SDG 10 (Reduced Inequalities)"
    },
    {
      "slug": "sdg-11-(sustainable-cities-and-communities)",
      "name": "SDG 11 (Sustainable Cities and Communities)"
    },
    {
      "slug": "sdg-12-(responsible-consumption-and-production)",
      "name": "SDG 12 (Responsible Consumption and Production)"
    },
    {
      "slug": "sdg-13-(climate-action)",
      "name": "SDG 13 (Climate Action)"
    },
    {
      "slug": "sdg-14-(life-below-water)",
      "name": "SDG 14 (Life Below Water)"
    },
    {
      "slug": "sdg-15-(life-on-land)",
      "name": "SDG 15 (Life on Land)"
    },
    {
      "slug": "sdg-16-(peace-justice-and-strong-institutions)",
      "name": "SDG 16 (Peace Justice and Strong Institutions)"
    },
    {
      "slug": "sdg-17-(partnerships-for-the-goals)",
      "name": "SDG 17 (Partnerships for the Goals)"
    }
  ],
  "thematic_focuses": [
    {
      "slug": "circular-economy",
      "name": "Circular Economy"
    },
    {
      "slug": "climate---energy-transition",
      "name": "Climate / Energy Transition"
    },
    {
      "slug": "food-systems---sustainable-agriculture",
      "name": "Food Systems / Sustainable Agriculture"
    },
    {
      "slug": "gender---inclusive-finance",
      "name": "Gender / Inclusive Finance"
    },
    {
      "slug": "healthcare-access",
      "name": "Healthcare Access"
    },
    {
      "slug": "impact-first---commercial-plus",
      "name": "Impact-first / Commercial-plus"
    },
    {
      "slug": "infrastructure",
      "name": "Infrastructure"
    },
    {
      "slug": "real-estate---affordable-housing",
      "name": "Real Estate / Affordable Housing"
    },
    {
      "slug": "smes---msmes",
      "name": "SMEs / MSMEs"
    }
  ],
  "preferred_fund_types": [
    {
      "slug": "buyout",
      "name": "Buyout"
    },
    {
      "slug": "fund-of-funds-(fof)",
      "name": "Fund of Funds (FoF)"
    },
    {
      "slug": "growth-private-equity",
      "name": "Growth Private Equity"
    },
    {
      "slug": "infrastructure",
      "name": "Infrastructure"
    },
    {
      "slug": "private-credit",
      "name": "Private Credit"
    },
    {
      "slug": "real-estate",
      "name": "Real Estate"
    },
    {
      "slug": "venture-capital",
      "name": "Venture Capital"
    }
  ],
  "fund_investment_strategies": [
    {
      "slug": "co-investment",
      "name": "Co-investment"
    },
    {
      "slug": "direct-investment",
      "name": "Direct Investment"
    },
    {
      "slug": "fund-investment",
      "name": "Fund Investment"
    }
  ],
  "fund_types": [
    {
      "slug": "private-equity",
      "name": "Private Equity"
    },
    {
      "slug": "venture-capital",
      "name": "Venture Capital"
    },
    {
      "slug": "private-credit",
      "name": "Private Credit"
    },
    {
      "slug": "infrastructure",
      "name": "Infrastructure"
    },
    {
      "slug": "real-estate",
      "name": "Real Estate"
    },
    {
      "slug": "impact-fund",
      "name": "Impact Fund"
    }
  ],
  "fund_statuses": [
    {
      "slug": "active",
      "name": "Active"
    },
    {
      "slug": "closed",
      "name": "Closed"
    },
    {
      "slug": "fully-invested",
      "name": "Fully Invested"
    },
    {
      "slug": "exited",
      "name": "Exited"
    }
  ],
  "nature_of_fund": [
    {
      "slug": "independent",
      "name": "Independent"
    },
    {
      "slug": "captive",
      "name": "Captive"
    },
    {
      "slug": "semi-captive",
      "name": "Semi-Captive"
    }
  ],
  "fund_strategies": [
    {
      "slug": "seed-&-early-stage",
      "name": "Seed & Early-stage"
    },
    {
      "slug": "expansion-/-late-stage",
      "name": "Expansion / Late-stage"
    },
    {
      "slug": "growth-equity",
      "name": "Growth Equity"
    },
    {
      "slug": "buyout",
      "name": "Buyout"
    },
    {
      "slug": "mezzanine",
      "name": "Mezzanine"
    },
    {
      "slug": "direct-lending",
      "name": "Direct Lending"
    },
    {
      "slug": "venture-debt",
      "name": "Venture Debt"
    },
    {
      "slug": "distressed-/-special-situations",
      "name": "Distressed / Special Situations"
    },
    {
      "slug": "fund-of-funds",
      "name": "Fund of Funds"
    },
    {
      "slug": "secondaries-(lp-led-&-gp-led/continuation-vehicles)",
      "name": "Secondaries (LP-led & GP-led/continuation vehicles)"
    }
  ],
  "gp_instruments": [
    {
      "slug": "equity",
      "name": "Equity"
    },
    {
      "slug": "debt",
      "name": "Debt"
    },
    {
      "slug": "mezzanine",
      "name": "Mezzanine"
    },
    {
      "slug": "safe",
      "name": "SAFE"
    }
  ],
  "fund_financing_types": [
    {
      "slug": "direct",
      "name": "Direct"
    },
    {
      "slug": "indirect",
      "name": "Indirect"
    },
    {
      "slug": "equity",
      "name": "Equity"
    },
    {
      "slug": "debt",
      "name": "Debt"
    }
  ],
  "asset_classes": [
    {
      "slug": "private-equity",
      "name": "Private Equity"
    },
    {
      "slug": "venture-capital",
      "name": "Venture Capital"
    },
    {
      "slug": "private-credit",
      "name": "Private Credit"
    },
    {
      "slug": "infrastructure-&-project-finance",
      "name": "Infrastructure & Project Finance"
    },
    {
      "slug": "real-estate",
      "name": "Real Estate"
    },
    {
      "slug": "natural-resources",
      "name": "Natural Resources"
    },
    {
      "slug": "corporate-transactions",
      "name": "Corporate Transactions"
    }
  ],
  "lp_legal_structures": [
    {
      "slug": "private",
      "name": "Private"
    },
    {
      "slug": "public",
      "name": "Public"
    },
    {
      "slug": "statutory",
      "name": "Statutory"
    },
    {
      "slug": "trust",
      "name": "Trust"
    },
    {
      "slug": "other",
      "name": "Other"
    }
  ],
  "lp_ticket_types": [
    {
      "slug": "anchor-lp",
      "name": "Anchor LP"
    },
    {
      "slug": "passive-lp",
      "name": "Passive LP"
    }
  ],
  "hq_regions": [
    {
      "slug": "western-africa",
      "name": "Western Africa"
    },
    {
      "slug": "eastern-africa",
      "name": "Eastern Africa"
    },
    {
      "slug": "southern-africa",
      "name": "Southern Africa"
    },
    {
      "slug": "northern-africa",
      "name": "Northern Africa"
    },
    {
      "slug": "central-africa",
      "name": "Central Africa"
    },
    {
      "slug": "europe",
      "name": "Europe"
    },
    {
      "slug": "northern-america",
      "name": "Northern America"
    },
    {
      "slug": "central-america",
      "name": "Central America"
    },
    {
      "slug": "southern-america",
      "name": "Southern America"
    },
    {
      "slug": "middle-east",
      "name": "Middle East"
    },
    {
      "slug": "asia",
      "name": "Asia"
    },
    {
      "slug": "australia",
      "name": "Australia"
    }
  ]
}
